import {
  SupplierApiError,
  mapSupplierApiError,
  supplierGetAndParse,
  supplierPostAndParse,
} from './supplierApiCore';
import {
  correctSupplierFactorResponseV1Schema,
  publishSupplierFactorResponseV1Schema,
  supplierFactorHistoryResponseV1Schema,
  supplierFactorListResponseV1Schema,
  withdrawSupplierFactorResponseV1Schema,
} from './supplierFactorContracts';

export const SUPPLIER_FACTOR_ENDPOINTS = Object.freeze({
  list: '/supplier/factors',
  history: (historyAnchorRevisionId) => `/supplier/factors/${historyAnchorRevisionId}/history`,
  publish: '/supplier/factors/publish',
  correct: '/supplier/factors/correct',
  withdraw: (revisionId) => `/supplier/factors/${revisionId}/withdraw`,
});

export class SupplierFactorApiError extends SupplierApiError {
  constructor(payload, httpStatus) {
    super(payload, httpStatus, 'Supplier factor request failed');
    this.name = 'SupplierFactorApiError';
  }
}

const mapApiError = (error) => mapSupplierApiError(error, SupplierFactorApiError);

const getAndParse = (endpoint, schema) => supplierGetAndParse(endpoint, schema, mapApiError);
const postAndParse = (endpoint, body, schema) =>
  supplierPostAndParse(endpoint, body, schema, mapApiError);

export const fetchSupplierFactors = () =>
  getAndParse(SUPPLIER_FACTOR_ENDPOINTS.list, supplierFactorListResponseV1Schema);

export const fetchSupplierFactorHistory = (historyAnchorRevisionId) =>
  getAndParse(
    SUPPLIER_FACTOR_ENDPOINTS.history(historyAnchorRevisionId),
    supplierFactorHistoryResponseV1Schema,
  );

export const publishSupplierFactor = (body) =>
  postAndParse(SUPPLIER_FACTOR_ENDPOINTS.publish, body, publishSupplierFactorResponseV1Schema);

export const correctSupplierFactor = (body) =>
  postAndParse(SUPPLIER_FACTOR_ENDPOINTS.correct, body, correctSupplierFactorResponseV1Schema);

// Withdraw carries the versioned empty body the backend requires. An in-use
// revision (referenced by persisted declarant data, D23/D-10) comes back as an
// error whose message is surfaced verbatim so the supplier learns why it cannot
// be withdrawn and can publish a correction instead.
export const withdrawSupplierFactor = (revisionId) =>
  postAndParse(
    SUPPLIER_FACTOR_ENDPOINTS.withdraw(revisionId),
    { version: 1 },
    withdrawSupplierFactorResponseV1Schema,
  );
